/* Hallows Night — barra fija de compra en móvil.
   Reutiliza el formulario real de la ficha de producto (variantes, cantidad y
   carrito lateral de Dawn incluidos). */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-hn-sticky]');
    if (!bar || bar.hnReady) return;

    var form = document.querySelector('product-form form[data-type="add-to-cart-form"]');
    var mainButton = document.querySelector('.product-form__submit');
    if (!form || !mainButton) return;
    bar.hnReady = true;

    var priceOut = bar.querySelector('[data-hn-sticky-price]');
    var submit = bar.querySelector('[data-hn-sticky-submit]');
    var mainPriceBox = document.querySelector('.product__info-container .price');

    document.body.classList.add('hn-has-sticky');
    bar.removeAttribute('hidden');

    // Copia el precio visible de la ficha (Dawn lo re-renderiza al cambiar variante)
    function syncPrice() {
      if (!mainPriceBox || !priceOut) return;
      var sale = mainPriceBox.querySelector('.price__sale .price-item--sale');
      var regular = mainPriceBox.querySelector('.price__regular .price-item--regular');
      var source = mainPriceBox.classList.contains('price--on-sale') && sale ? sale : regular;
      if (source && source.textContent.trim()) priceOut.textContent = source.textContent.trim();
    }

    function syncState() {
      var disabled = mainButton.hasAttribute('disabled');
      submit.disabled = disabled;
      var label = mainButton.querySelector('span');
      if (label && label.textContent.trim()) submit.textContent = label.textContent.trim();
    }

    syncPrice();
    syncState();

    var info = document.querySelector('.product__info-container') || document.body;
    var mo = new MutationObserver(function () {
      mainPriceBox = document.querySelector('.product__info-container .price');
      mainButton = document.querySelector('.product-form__submit') || mainButton;
      syncPrice();
      syncState();
    });
    mo.observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });

    submit.addEventListener('click', function () {
      if (submit.disabled) return;
      var current = document.querySelector('product-form form[data-type="add-to-cart-form"]') || form;
      if (typeof current.requestSubmit === 'function') {
        current.requestSubmit();
      } else {
        var btn = current.querySelector('[type="submit"]');
        if (btn) btn.click();
      }
    });

    // Se muestra cuando el botón principal ya ha quedado por ENCIMA de la
    // pantalla (el usuario pasó de largo). Se comprueba en cada scroll, con
    // rAF para no recalcular más de una vez por fotograma.
    var timer = null;
    function check() {
      timer = null;
      var btn = document.querySelector('.product-form__submit') || mainButton;
      var r = btn.getBoundingClientRect();
      bar.classList.toggle('is-visible', r.bottom < 0);
    }
    function onScroll() {
      if (timer) return;
      timer = window.setTimeout(check, 60);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
